/**
 * Updates all section status in a container element.
 * @param {Element} main The container element
 */
export function updateSectionsStatus(main) {
    const sections = Array.from(main.querySelectorAll(':scope > div.section'));
    for (let i = 0; i < sections.length; i += 1) {
        const section = sections[i];
        const status = section.dataset.sectionStatus;
        if (status !== 'loaded') {
            const loadingBlock = section.querySelector('.block[data-block-status="initialized"], .block[data-block-status="loading"]');
            if (loadingBlock) {
                section.dataset.sectionStatus = 'loading';
                break;
            }
            else {
                section.dataset.sectionStatus = 'loaded';
                section.style.display = '';
            }
        }
    }
}
//# sourceMappingURL=updateSectionsStatus.mjs.map